import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxWebsocket from '@giantmachines/redux-websocket';
import thunk from 'redux-thunk';

import './helpers/yup';

import App from './containers/App';

import Amplify from 'aws-amplify';
import cognitoData from './awsConfig';

import unwrapReduxWebsocket from './middleware/unwrapReduxWebsocket';
import reducers from './reducers';
import Snackbar from './components/Snackbar';

import {  MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import 'typeface-roboto';
import './index.css';


Amplify.configure({
    Auth: {
        mandatorySignIn:     true,
        identityPoolRegion:  cognitoData.aws.cognito.region,
        region:              cognitoData.aws.cognito.region,
        userPoolId:          cognitoData.aws.cognito.userPoolId,
        identityPoolId:      cognitoData.aws.cognito.identityPoolId,
        userPoolWebClientId: cognitoData.aws.cognito.clientId
    }
});

const theme = createTheme({
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Oxygen',
            'Ubuntu',
            'Cantarell',
            'Fira Sans',
            'Droid Sans',
            'Helvetica Neue',
            'sans-serif'
        ].join(','),
        useNextVariants: true
    },
    palette: {
        primary: {
            main: '#5174fa',
        },
        secondary: {
            main: '#5174fa',
        }
    }
});

const reduxWebsocketMiddleware = reduxWebsocket({ reconnectOnClose: true });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    reducers,
    composeEnhancers(
        applyMiddleware(
            thunk,
            reduxWebsocketMiddleware,
            unwrapReduxWebsocket
        )
    )
);

ReactDOM.render(
    <BrowserRouter>
        <MuiThemeProvider theme={theme}>
            <Provider store={store}>
                <Typography component={'div'}>
                    <Snackbar />
                    <App />
                </Typography>
            </Provider>
        </MuiThemeProvider>
    </BrowserRouter>, document.getElementById('root')
);
